import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";

var defaults = require("lodash/defaults");

export var PaginationHelper =
/*#__PURE__*/
function () {
  function PaginationHelper(_ref) {
    var currentPage = _ref.currentPage,
        totalPages = _ref.totalPages,
        translate = _ref.translate;

    _classCallCheck(this, PaginationHelper);

    this.currentPage = currentPage;
    this.totalPages = totalPages;
    this.translate = translate;
    this.pages = [];
    this.lastPage = 0; // Last added page number
  }

  _createClass(PaginationHelper, [{
    key: "push",
    value: function push(item) {
      this.pages.push(item);
    }
  }, {
    key: "previous",
    value: function previous() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.push(defaults({
        key: "previous",
        label: this.translate('pagination.previous'),
        page: this.currentPage > 1 ? this.currentPage - 1 : undefined,
        disabled: this.currentPage === 1
      }, options));
    }
  }, {
    key: "next",
    value: function next() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.push(defaults({
        key: "next",
        label: this.translate('pagination.next'),
        page: this.currentPage < this.totalPages - 1 ? this.currentPage + 1 : undefined,
        disabled: this.currentPage === this.totalPages
      }, options));
    }
  }, {
    key: "page",
    value: function page(pageNumber) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (pageNumber > 0 && pageNumber <= this.totalPages) {
        this.push(defaults({
          key: pageNumber,
          label: '' + pageNumber,
          page: pageNumber,
          active: pageNumber == this.currentPage
        }, options));
      }
    }
  }, {
    key: "range",
    value: function range(minPage, maxPage) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var min = Math.max(1, minPage);
      var max = Math.min(maxPage, this.totalPages);

      for (var i = min; i <= max; i++) {
        this.page(i, options);
      }
    }
  }, {
    key: "ellipsis",
    value: function ellipsis() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.push(defaults({
        key: "ellipsis-" + this.pages.length,
        label: '...',
        disabled: true
      }, options));
    }
  }]);

  return PaginationHelper;
}();
export var Paginator = {
  build: function build(_ref2) {
    var _ref2$showNumbers = _ref2.showNumbers,
        showNumbers = _ref2$showNumbers === void 0 ? true : _ref2$showNumbers,
        _ref2$showPrevious = _ref2.showPrevious,
        showPrevious = _ref2$showPrevious === void 0 ? true : _ref2$showPrevious,
        _ref2$showNext = _ref2.showNext,
        showNext = _ref2$showNext === void 0 ? true : _ref2$showNext,
        _ref2$showEllipsis = _ref2.showEllipsis,
        showEllipsis = _ref2$showEllipsis === void 0 ? true : _ref2$showEllipsis,
        _ref2$showFirst = _ref2.showFirst,
        showFirst = _ref2$showFirst === void 0 ? true : _ref2$showFirst,
        _ref2$showLast = _ref2.showLast,
        showLast = _ref2$showLast === void 0 ? false : _ref2$showLast;
    return function (currentPage, totalPages, translate) {
      var pageScope = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 3;
      var builder = new PaginationHelper({
        currentPage: currentPage,
        totalPages: totalPages,
        translate: translate
      });
      if (showPrevious) builder.previous();

      if (showNumbers) {
        if (showFirst && currentPage > pageScope + 1) builder.page(1);
        if (showEllipsis && currentPage > pageScope + 2) builder.ellipsis();
        builder.range(currentPage - pageScope, currentPage - 1);
        builder.page(currentPage, {
          active: true
        });
        builder.range(currentPage + 1, currentPage + pageScope);
        var lastEllipsisLimit = showLast ? totalPages - pageScope - 1 : totalPages - pageScope;
        if (showEllipsis && currentPage < lastEllipsisLimit) builder.ellipsis();
        if (showLast && currentPage < totalPages - pageScope) builder.page(totalPages);
      }

      if (showNext) builder.next();
      return builder.pages;
    };
  }
};